import { createReducer, on } from '@ngrx/store';
import _ from 'lodash';
import { getUser, saveUser } from './user.actions';

export const saveUserReducer = (_: any, { value }: { value: any }): any =>
    value;

export const getUserReducer = (user: any): any => user;

// export const saveReservationReducer = (
//     _: any,
//     { value }: { value: any },
// ): any => value;

// export const clearReservationReducer = () => {
//     return {};
// };

// export const updateReservationReducer = (
//     previus: any,
//     { value }: { value: any },
// ): any => {
//     return _.mergeWith({}, previus, value, (objValue, srcValue) => {
//         if (Array.isArray(objValue)) {
//             return srcValue;
//         }
//     });
// };

export const UserReducer = createReducer(
    {},
    on(saveUser, saveUserReducer),
    on(getUser, getUserReducer),
    // on(updateReservation, updateReservationReducer),
    // on(clearReservation, clearReservationReducer),
);
